import axios from "axios";

import env from "../environments";

type SelectDeliverableParams = {
	readonly id: string;
};

type SelectDeliverableResponse = {
	success: boolean;
};

export async function selectBlockMessageDeliverable({ id }: SelectDeliverableParams) {
	const response = await axios.patch<SelectDeliverableResponse>(
		`${env.apiUrl}/block-messages/${id}/select-deliverable`,
	);

	return response.data;
}
